"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("../Themes/styled-components"));
var Label = styled_components_1.default.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var Input = styled_components_1.default.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n  white-space: nowrap;\n\n  &:checked + span {\n    background-color: #4a9dff;\n\n    &::before {\n      transform: translate(16px, -50%);\n    }\n  }\n\n  &:disabled + span {\n    opacity: 0.5;\n    cursor: not-allowed;\n\n    &::before {\n      background-color: rgba(32, 37, 50, 0.14);\n    }\n  }\n"], ["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n  white-space: nowrap;\n\n  &:checked + span {\n    background-color: #4a9dff;\n\n    &::before {\n      transform: translate(16px, -50%);\n    }\n  }\n\n  &:disabled + span {\n    opacity: 0.5;\n    cursor: not-allowed;\n\n    &::before {\n      background-color: rgba(32, 37, 50, 0.14);\n    }\n  }\n"])));
var Toggle = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  box-sizing: border-box;\n  margin: 0 9px;\n  width: 36px;\n  height: 22px;\n  border-radius: 30px;\n  background-color: rgba(32, 37, 50, 0.14);\n  box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.2);\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n\n  &::before {\n    transition: transform 75ms ease-in-out;\n    content: '';\n    display: block;\n    width: 18px;\n    height: 18px;\n    background-color: #fff;\n    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.25),\n      0 2px 8px 0 rgba(32, 37, 50, 0.16);\n    position: absolute;\n    border-radius: 100%;\n    top: 11px;\n    transform: translate(2px, -50%);\n  }\n"], ["\n  box-sizing: border-box;\n  margin: 0 9px;\n  width: 36px;\n  height: 22px;\n  border-radius: 30px;\n  background-color: rgba(32, 37, 50, 0.14);\n  box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.2);\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n\n  &::before {\n    transition: transform 75ms ease-in-out;\n    content: '';\n    display: block;\n    width: 18px;\n    height: 18px;\n    background-color: #fff;\n    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.25),\n      0 2px 8px 0 rgba(32, 37, 50, 0.16);\n    position: absolute;\n    border-radius: 100%;\n    top: 11px;\n    transform: translate(2px, -50%);\n  }\n"])));
var Switch = /** @class */ (function (_super) {
    __extends(Switch, _super);
    function Switch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Switch.prototype.render = function () {
        var _a = this.props, checked = _a.checked, disabled = _a.disabled, restProps = __rest(_a, ["checked", "disabled"]);
        return (React.createElement(Label, null,
            React.createElement(Input, __assign({}, restProps, { type: "checkbox", checked: checked, disabled: disabled })),
            React.createElement(Toggle, null)));
    };
    return Switch;
}(React.PureComponent));
exports.default = Switch;
var templateObject_1, templateObject_2, templateObject_3;
